import React from 'react'

function FacilityCard({ title, description, order_no, image }) {
  return (
    <div className='facilityCard' data-aos="fade-up">
      <h1>{title}</h1>
      <p>{description}</p>
      <img src={image && image} alt="Facility" />
    </div>
  )
}

export default FacilityCard